import { AnsweringClient, IInstrument } from "../clients/answeringClient";

export interface CheckoutReviewControllerDelegate {
  didGetInstruments(instruments: IInstrument[]): void;
  applicationShouldLogout(): void;
  genericError(message?: string): void;
}

export class CheckoutReviewController {
  constructor(
    private delegate: CheckoutReviewControllerDelegate,
    private readonly answeringClient = new AnsweringClient()
  ) {}

  public async getManagedInstruments(
    accessToken: string,
    instrumentIds?: number[]
  ) {
    try {
      const response = await this.answeringClient.getAllManagedInstruments(
        accessToken
      );
      let data = response.data.map((instrument) => ({
        title: instrument.title,
        description: instrument.description,
        priceInBrlCents: instrument.priceInBrlCents,
        quantity: instrument.quantity,
        id: instrument.id,
      })) as IInstrument[];

      if (instrumentIds?.length) {
        const allowedIds = new Set(instrumentIds);
        data = data.filter((instrument) => allowedIds.has(instrument.id));
      }

      this.delegate.didGetInstruments(data);
    } catch (error: any) {
      if (error?.response?.status === 403) {
        const newTokens = await this.refreshTokens();
        if (!newTokens) {
          return;
        }
        this.getManagedInstruments(newTokens.accessToken, instrumentIds);
        return;
      }
      this.delegate.genericError(
        "Não foi possível carregar os detalhes dos instrumentos."
      );
    }
  }

  private async refreshTokens(): Promise<{
    accessToken: string;
    refreshToken: string;
  } | void> {
    const refreshToken = localStorage.getItem("RefreshToken");
    if (!refreshToken) {
      this.delegate.applicationShouldLogout();
      return;
    }
    try {
      const response = await this.answeringClient.refreshToken(refreshToken);
      const tokens: { accessToken: string; refreshToken: string } =
        response.data;
      localStorage.setItem("AccessToken", tokens.accessToken);
      localStorage.setItem("RefreshToken", tokens.refreshToken);
      return tokens;
    } catch (error: any) {
      this.delegate.applicationShouldLogout();
      return;
    }
  }
}
